import axios from "axios";
import { DateHelpers } from "../../Helpers/Date/DateHelpers";

const BASE_URL = `/m-1/config`;

export const ConfigService = {
  getConfigByKey,
  getDeadlines,
  getDeadlinesFormattedToContext,
};

function getConfigByKey(key) {
  return axios.get(`${BASE_URL}/${key}`);
}

/**
 * Fetch all deadline-related configuration.
 *
 * @returns {Promise<AxiosResponse>}
 */
function getDeadlines() {
  return axios.get(`${BASE_URL}/deadlines`);
}

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const parseDate = (value) => {
  const date = new Date(value);

  return isNaN(date.getTime()) ? null : date;
};

function setContractData(data, contractNumber, type, response) {
  const prefix = `${contractNumber}-contract-${type}`;
  const contractName = capitalize(contractNumber);
  const typeName = capitalize(type);

  const enabledKey = `is${contractName}Contract${typeName}DeadlineEnabled`;
  const timeKey = `${contractNumber}Contract${typeName}TimeToSign`;
  const passKey = `is${contractName}Contract${typeName}PassTimeToSign`;
  const inScopeKey = `is${contractName}Contract${typeName}InDeadlineScope`;

  const deadlineKey = `${prefix}-deadline-termin-to-signed`;
  const rawDeadline = response.data?.[deadlineKey];
  const timeToSign = rawDeadline ? parseDate(rawDeadline) : null;

  data[enabledKey] = response.data[`${prefix}-deadline-is-enabled`] === "1";
  data[timeKey] = timeToSign;
  data[passKey] = timeToSign ? timeToSign < new Date() : false;
  data[inScopeKey] = DateHelpers.isCurrentDateInRange(
    response.data[`${prefix}-deadline-from`],
    response.data[`${prefix}-deadline-to`]
  );
}

/**
 * Fetch deadlines and format to user context.
 *
 * @param {UserContext} user
 * @returns {DeadlineContext}
 */
async function getDeadlinesFormattedToContext(user) {
  const response = await getDeadlines();
  
  const dataRaw = response?.data ?? response;

  if (!dataRaw) {
    console.error("ConfigService.getDeadlinesFormattedToContext: no data returned", response);
    return {};
  }

  const contractNumbers = ['first', 'second'];
  const recruitmentTypes = ['standard', 'special', 'new'];

  const data = {};

  contractNumbers.forEach((contract) => {
    recruitmentTypes.forEach((type) => {
      setContractData(data, contract, type, response);
    });
  });

  const contractRecruitmentTypes = user?.contractRecruitmentTypes ?? { "1": "standard", "2": "standard" };

  contractNumbers.forEach((contractNumber, idx) => {
    const contractKey = (idx + 1).toString();
    const recruitmentType = contractRecruitmentTypes[contractKey];
    const prefix = `${contractNumber}-contract-${recruitmentType}`;

    data[`${contractNumber}ContractFrom`] = parseDate(response.data[`${prefix}-deadline-from`]);
    data[`${contractNumber}ContractTo`] = parseDate(response.data[`${prefix}-deadline-to`]);
  });

  return data;
}
